import React, { useMemo, useState } from 'react';
import { Button } from 'components/ui/button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencil, faTrash } from '@fortawesome/pro-solid-svg-icons';
import { faFileSpreadsheet } from '@fortawesome/pro-regular-svg-icons';
import { formatDate, SHORT_DATE_FORMAT } from '../../../../helpers/formatters/date_time_formats';
import EmptyState from '../empty_state';
import Paginator from '../paginator';
import type { DataExportTemplate } from 'bundles/connect/types';

type Props = {
  templates: DataExportTemplate[];
  onDeleteTemplate: (template: DataExportTemplate) => void;
  onEditTemplate: (template: DataExportTemplate) => void;
}

const PER_PAGE = 5;
export default function TemplateList({ templates, onDeleteTemplate, onEditTemplate }: Props) {
  const [page, setPage] = useState(1);
  const paginatedResults = useMemo(() => {
    return templates.slice((page - 1) * PER_PAGE, page * PER_PAGE);
  }, [templates, page]);

  return (
    <div>
      {templates.length > 0 ? (
        <>
          {paginatedResults.map(template => (
            <div className="d-flex gap-2 border-bottom py-2" key={template.id}>
              <FontAwesomeIcon className="py-1" icon={faFileSpreadsheet} size="lg"/>
              <div className="flex-grow-1">
                <div className="fw-bold">
                  {template.name}
                </div>
                <div className="text-muted small">
                  Created {formatDate(template.createdAt, SHORT_DATE_FORMAT)}
                </div>
              </div>
              <div className="d-flex gap-2">
                <Button icon={faPencil} label="Edit" variant="ghost" onClick={() => onEditTemplate(template)} />
                <Button
                  className="text-danger"
                  icon={faTrash}
                  label="Delete"
                  variant="ghost"
                  onClick={() => onDeleteTemplate(template)}
                />
              </div>
            </div>
          ))}
          {templates.length > PER_PAGE && (
            <div className="d-flex justify-content-center mt-6">
              <Paginator currentPage={page} perPage={PER_PAGE} total={templates.length} onSelect={setPage}/>
            </div>
          )}
        </>
      ) : (
        <EmptyState icon={faFileSpreadsheet} iconSize="2x" title="You don't have any data export templates" />
      )}
    </div>
  );
}
